export enum FunnelEventMarketing {
  CanStartOnChosen = 'can_start_on_chosen',
  CvFilesUploaded = 'registration_cv_uploaded',
  DesiredPositionChosen = 'desired_position_chosen',
  DesiredUnitsChosen = 'desired_units_chosen',
  EmployerTypeChosen = 'employer_type_chosen',
  EmploymentRelationshipChosen = 'employment_relationship_chosen',
  EmploymentScheduleChosen = 'employment_schedule_chosen',
  FurtherQualificationsChosen = 'further_qualifications_chosen',
  GermanLevelChosen = 'german_level_chosen',
  Has3YearExamAnswered = 'has_3_year_exam_answered',
  HasApprenticeshipAnswered = 'has_apprenticeship_answered',
  HasCertificationAnswered = 'has_certification_answered',
  HasDriversLicenseAnswered = 'has_drivers_license_answered',
  HasFurtherQualificationsAnswered = 'has_further_qualifications_answered',
  HasNursingApprenticeshipAnswered = 'has_nursing_apprenticeship_answered',
  IsDeputyPositionChosen = 'is_deputy_position_chosen',
  JobYearsOfExperienceAnswered = 'job_years_of_experience_answered',
  LocationChosen = 'location_chosen',
  NursingAreaChosen = 'nursing_area_chosen',
  RegistrationStarted = 'registration_started',
  RegistrationCompleted = 'registration_completed',
  RegistrationCompletedPraxia = 'registration_completed_praxia',
  RegistrationMultiposting = 'registration_multiposting',
  RegistrationStep1Completed = 'registration_step1_completed',
  YearsOfExperienceAnswered = 'years_of_experience_answered',
  CaregiverQualificationAnswered = 'caregiver_qualification_answered',
  RecognitionUpdated = 'recognition_updated',
  AreaStepViewed = 'area_step_viewed',
  AreaStepCompleted = 'area_step_completed',
  AreaStepSkipped = 'area_step_skipped',

  // not used events
  PersonalDataProvided = 'personal_data_answered',
  ExternalRegistrationCompleted = 'external_registration_completed',
  JobQualificationProvided = 'job_qualification_provided',
  HighlightJobTitleChosen = 'highlight_job_title_chosen',

  // used after the funnel registration
  PhoneNumberProvided = 'phone_number_answered',
}
